module.exports = __webpack_public_path__ + "img/actionImg1@2x.4d15e555.jpg";